import { usePosterContext } from "../../../context/poster-context";
import { PosterInfoType } from "../../../hooks/use-poster";
import Address from "./address";
import Info from "./info";
import MainInfo from "./main-info";
import Notice from "./notice";
import PrizePool from "./prize-pool";
import Structure from "./structure";
import Image from "./image";
import {
  EditIsHideLine,
  EditLine,
  EditTabHeader,
  EditTabHeaderItem,
  EditWrapper,
} from "../styles";
import { Checkbox } from "../../../../../styles/page";

const EditAllInfo = () => {
  const { infoType, setInfoType, isHideLine, setIsHideLine } =
    usePosterContext();
  return (
    <EditWrapper>
      <EditTabHeader>
        <div className="list">
          <EditTabHeaderItem
            selected={infoType === PosterInfoType.MAIN}
            onClick={() => setInfoType(PosterInfoType.MAIN)}
          >
            메인
          </EditTabHeaderItem>
          <EditTabHeaderItem
            selected={infoType === PosterInfoType.INFO}
            onClick={() => setInfoType(PosterInfoType.INFO)}
          >
            정보
          </EditTabHeaderItem>
          <EditTabHeaderItem
            selected={infoType === PosterInfoType.NOTICE}
            onClick={() => setInfoType(PosterInfoType.NOTICE)}
          >
            공지
          </EditTabHeaderItem>
          <EditTabHeaderItem
            selected={infoType === PosterInfoType.PRIZE_POOL}
            onClick={() => setInfoType(PosterInfoType.PRIZE_POOL)}
          >
            프라이즈풀
          </EditTabHeaderItem>
          <EditTabHeaderItem
            selected={infoType === PosterInfoType.STRUCTURE}
            onClick={() => setInfoType(PosterInfoType.STRUCTURE)}
          >
            스트럭쳐
          </EditTabHeaderItem>
          <EditTabHeaderItem
            selected={infoType === PosterInfoType.ADDRESS}
            onClick={() => setInfoType(PosterInfoType.ADDRESS)}
          >
            주소
          </EditTabHeaderItem>
          <EditTabHeaderItem
            selected={infoType === PosterInfoType.IMAGE}
            onClick={() => setInfoType(PosterInfoType.IMAGE)}
          >
            이미지 첨부
          </EditTabHeaderItem>
        </div>
        <EditIsHideLine>
          <div className="label">점선 숨기기</div>
          <Checkbox
            checked={isHideLine}
            onChange={() => setIsHideLine(!isHideLine)}
          />
        </EditIsHideLine>
      </EditTabHeader>
      <EditLine />
      {infoType === PosterInfoType.MAIN && <MainInfo />}
      {infoType === PosterInfoType.INFO && <Info />}
      {infoType === PosterInfoType.NOTICE && <Notice />}
      {infoType === PosterInfoType.PRIZE_POOL && <PrizePool />}
      {infoType === PosterInfoType.STRUCTURE && <Structure />}
      {infoType === PosterInfoType.ADDRESS && <Address />}
      {infoType === PosterInfoType.IMAGE && <Image />}
    </EditWrapper>
  );
};

export default EditAllInfo;
